import React, { useCallback, useState } from "react";

import { Card } from "semantic-ui-react";

import {
  CrmAccessDisclaimer,
  CrmHeader,
  CrmOption,
  RedtailSection,
  SkipIntegrationButton,
  WealthboxSection,
} from "./components";

export function CrmIntegrationStep() {
  const [selectedCrm, setSelectedCrm] = useState("");

  return (
    <div
      style={{
        border: "1px solid #C9C9C9",
        padding: "40px",
        width: "100%",
        maxWidth: "670px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CrmHeader />

      <Card.Group
        style={{
          maxWidth: "600px",
          padding: selectedCrm ? "50px 0" : "50px 0 0 0 ",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        itemsPerRow={3}
      >
        <CrmOption
          name="Wealthbox"
          imgUrl="/images/logos/wealthbox-logo.png"
          selected={selectedCrm === "Wealthbox"}
          onClick={useCallback(() => {
            setSelectedCrm("Wealthbox");
          }, [])}
        />

        <CrmOption
          name="Redtail"
          imgUrl="/images/logos/redtail-logo.png"
          selected={selectedCrm === "Redtail"}
          onClick={useCallback(() => {
            setSelectedCrm("Redtail");
          }, [])}
        />

        <SkipIntegrationButton />
      </Card.Group>

      {selectedCrm && (
        <div
          style={{
            width: "445px",
            alignSelf: "center",
            justifyContent: "space-around",
          }}
        >
          {selectedCrm === "Redtail" && (
            <RedtailSection>
              <CrmAccessDisclaimer crm={selectedCrm} />
            </RedtailSection>
          )}
          {selectedCrm === "Wealthbox" && (
            <WealthboxSection>
              <CrmAccessDisclaimer crm={selectedCrm} />
            </WealthboxSection>
          )}
        </div>
      )}
    </div>
  );
}

export default CrmIntegrationStep;
